import { lookupOrganizationStudentByEmail } from 'api/admin'

/**
 * Look up an existing student account by email for Add Student.
 * Returns null when no application user exists (404).
 */
export async function lookupStudentByEmail(email) {
	const normalized = String(email || '').trim()
	if (!normalized) {
		throw new Error('email is required')
	}

	try {
		const payload = await lookupOrganizationStudentByEmail(normalized)
		return payload?.student ?? null
	} catch (error) {
		if (error?.response?.status === 404) {
			return null
		}
		throw error
	}
}
